import { useRef, useEffect } from 'react';
import { getScrollDirection, canScrollInDirection } from '../../../Utils/dndScrollUtil';

export default function useDndAutoScroll({ threshold = 60, speed = 8 } = {}) {
  const scrollContainerRef = useRef(null);
  const scrollIntervalRef = useRef(null);
  const pointerYRef = useRef(0);
  const currentDirectionRef = useRef(null);

  useEffect(() => {
    const handlePointerMove = (e) => { pointerYRef.current = e.clientY; };
    document.addEventListener('pointermove', handlePointerMove);
    return () => document.removeEventListener('pointermove', handlePointerMove);
  }, []);

  function stopAutoScroll() {
    if (scrollIntervalRef.current) {
      clearInterval(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }
    currentDirectionRef.current = null;
  }

  function onDragMove() {
    const container = scrollContainerRef.current;
    if (!container) return;

    const direction = getScrollDirection(pointerYRef.current, container.getBoundingClientRect(), threshold);

    if (direction === currentDirectionRef.current) return;

    if (scrollIntervalRef.current) {
      clearInterval(scrollIntervalRef.current);
      scrollIntervalRef.current = null;
    }

    currentDirectionRef.current = direction;

    if (!direction || !canScrollInDirection(container, direction)) return;

    scrollIntervalRef.current = setInterval(() => {
      const liveDirection = getScrollDirection(pointerYRef.current, container.getBoundingClientRect(), threshold);

      if (liveDirection !== direction) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
        currentDirectionRef.current = liveDirection;
        return;
      }

      const atBoundary = direction === 'down'
        ? container.scrollTop >= container.scrollHeight - container.clientHeight
        : container.scrollTop <= 0;

      if (atBoundary) {
        clearInterval(scrollIntervalRef.current);
        scrollIntervalRef.current = null;
        // currentDirectionRef는 리셋하지 않음 → onDragMove 재시작 차단
      } else {
        container.scrollTop += direction === 'down' ? speed : -speed;
      }
    }, 16);
  }

  return { scrollContainerRef, onDragMove, stopAutoScroll };
}
